import React, { forwardRef, useEffect } from "react";

import PropTypes from "prop-types";
import Tooltip from "react-bootstrap/Tooltip";

const UpdatingTooltip = ({
  popper,
  children,
  ...props
}, ref) => {
  useEffect(() => {
    if (popper) {
      popper.scheduleUpdate();
    }
  }, [children, popper]);

  return (
    <Tooltip ref={ref} content {...props}>
      {children}
    </Tooltip>
  );
};

UpdatingTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  popper: PropTypes.node.isRequired,
};

// eslint-disable-next-line react/display-name
export default forwardRef((props, ref) => UpdatingTooltip(props, ref));
